var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99fd55f3776711b120b87f7c3f9950ff.js').default;export default
        Object.assign({}, scope_0 )
    